import { SecurityScorecardDataState } from '@pages/executive-reports-old/components/executive-reports-tabs/security-scorecard-report/store/states/security-scorecard.state';

export const securityScorecardStates = [SecurityScorecardDataState];
